import { createAction, createReducer } from "@reduxjs/toolkit"
import { api } from "./helpers/api"
import { LOADING_INITIAL_STATE, setFailed, setReceived, setRequested } from "modules/loader-watchers/helpers/loading"

// ACTIONS
const crewMemberCalendarRequested = createAction("crewMemberCalendar/requested")
const crewMemberCalendarReceived = createAction("crewMemberCalendar/received")
const crewMemberCalendarFailed = createAction("crewMemberCalendar/failed")

// REDUCER
const initialState = {
  ...LOADING_INITIAL_STATE,
  bookings: [],
  timeOff: [],
  journalNoteDates: []
}

const crewMemberCalendarReducer = createReducer(initialState, {
  [crewMemberCalendarRequested.type]: (state) => {
    setRequested(state)
  },
  [crewMemberCalendarReceived.type]: (state, action) => {
    setReceived(state)
    state.bookings = action.payload?.bookings || []
    state.timeOff = action.payload?.time_off || []
    state.journalNoteDates = action.payload?.journal_note_dates || []
  },
  [crewMemberCalendarFailed.type]: (state) => {
    setFailed(state)
  }
})

export default crewMemberCalendarReducer

// PUBLIC ACTIONS

/**
 * Get calendar data for a specific crew member
 * @param {string|number} crewMemberId - The crew member ID
 * @param {object} params - Query parameters (date_gteq, date_lteq)
 * @returns {Promise} API response
 */
export const getCrewMemberCalendar = (crewMemberId, params) =>
  api({
    url: `/guide/profiles/${crewMemberId}/calendar`,
    params: { ...params },
    onStart: crewMemberCalendarRequested.type,
    onSuccess: crewMemberCalendarReceived.type,
    onError: crewMemberCalendarFailed.type
  })
